import { post, fetch, Del, put } from "@/ask/axios";
import senderAddrBox from '@/components/userCenter/public/senderAddrBox.vue' //发件人地址库
import menberMenu from '@/components/userCenter/public/menberPageMenu.vue'
export default {
  components: { senderAddrBox,menberMenu},
  data() {
    return {
      api: {
        url: "",
        param: "",
        response: {},
        message: ""
      },
      titNames: "Pick-up service",
      titUrls: ",",

      queryWait:true,
      loading:false,
      haveOrder:true,
      addOrderBox:false,
      discernBox:false,
      discernBox1:false,

      sumbitTrueBtn:false,
      sumbitBtn:false,
      discernInfo:'',
      discernInfo1:'',
      ordTableData:[],
      PEReqiure:'Please fill in the contact email',
      VolumeWeightP:"Actual weight or volume required",
      isStartInfo:true, //是否赋值给收件人信息

      newSumCost:0,
      oldSumCost:0,
      sumCost:0,

      THBillNo:'',
      THInfo:'',
      curOrdInfo:[],
      

      // 页面显示 是国际
      WaybillType:0,
      pickUpCityNameEn:'',
      ordThShow:'',
      servTimeOptions:[],
      curShow:false,

      PlanCargoDate:'',

      OrderStartDate: "",
      OrderEndDate: "",
      currentPage:1,
      Skip: 0,
      Take: 10,
      Total:0,
      WayOpt:[
        {name:"ALL",val:0},
        {name:"Express",val:1},
        {name:"Air Freight",val:3},
      ],
      curOrdInfo:[],
     //输入

     wareAdd:'',
     AreaKey:'',

     userThWrite:[],

     INTorder:'',
     OnyInfo:'', //非关联
     OrderData:'',
     Concent:'',
     DestInfo:'',
     GoodsInfos:'',
     GoodsInfosTip:false,
     GoodsInfoTip:false,
     discernInfoTip:false,
     discernInfoTip1:false,

     Weight:'',
     Volume:'',
     Quantity:'',
     LinkManName:'', 
     LinkTel:'', 
     LinkEmail:'', 
     Address:'', 
     DestAddress:'',
     Remark:'',
     WeightTip:false,
     VolumeTip:false,
     QuantityTip:false,
     LinkManNameTip:false, 
     LinkTelTip:false, 
     LinkEmailTip:false, 
     AddressTip:false, 
     DestAddressTip:false,
     RemarkTip:false,
     PlanCargoDateTip:false,

      //  关联
      Waybill :'',
      WConcent:'',
      WInfo:'',
      WaynillInfo :'',
      EditCss:true,
      GoodsInfo:'',
      WayArr:[],

      LadingName:'',
      LadingPhone:'',
      LadingNameTip:false,
      LadingPhoneTip:false,
      pickCheck:false,

      PlanArriveDate:'',
      sumWeight:'',
      ThcheckAll:false,
      selIndex:[],
      // 预约时间日期
      //日期输入处理,结束日期不能大于开始日期
      pickerOptions: {
        disabledDate: time => {
          return this.dealDisabledDate(time)
        }
      },
      //日期输入处理,结束日期不能大于开始日期
      pickerBeginDateBefore: {
        disabledDate: time => {
          if (this.OrderEndDate) {
            return time.getTime() > Date.now() || time.getTime() > this.OrderEndDate;
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      //日期输入处理，结束日期不能大于开始日期
      pickerBeginDateAfter: {
        disabledDate: time => {
          let startDate = new Date(this.OrderStartDate);
          return time.getTime() < startDate.getTime() || time.getTime() > Date.now();
        }
      }, 


    }
  },
  created() {
    // 判断是否是国际
    this.THBillNo = this.$route.query.thNo
    this.getDetail()
    this.datetime()
  },
  watch: {
    LinkTel: function(newVal, oldVal) {
      let fareg = /^[0-9-]+$/
      if(!fareg.test(newVal)  && newVal!=''){ 
        this.LinkTel = oldVal
      }
    },
    LadingPhone: function(newVal, oldVal) {
      let fareg = /^[0-9-]+$/
      if(!fareg.test(newVal)  && newVal!=''){ 
        this.LadingPhone = oldVal
      }
    }
  },
  methods: {
    dealDisabledDate(time) {
      let flag = true
      for (let i = 0; i < this.servTimeOptions.length; i++) {
        const ele = this.servTimeOptions[i]
        if(time.getFullYear() == new Date(ele.Date).getFullYear() 
        && time.getMonth() == new Date(ele.Date).getMonth() 
        && time.getDate() == new Date(ele.Date).getDate()) {
          flag = false
        }
      }
      return flag
    },
    // 获取信息  判断关联非关联
    getDetail() {
      this.api.url = this.$api03 + '/api/PickupOrders/GetThInfo'
      this.api.param = {
        "THBillNo": this.THBillNo
      }
      post(this.api.url, this.api.param).then(res => {
        if(res.IsOK) {
          this.THOrderService = res.Results.THOrderService
          if(res.Results.THOrderService  == 1) {
            this.INTorder = false
            this.OnyInfo = res.Results.OnyInfo
            this.Concent = res.Results.OnyInfo.Con
            this.OrderData = res.Results.OnyInfo.Order
            this.sumCost = this.OrderData.Cost
            this.flaseOrd()
          } else {
            this.INTorder = true
            this.Waybill = res.Results.Waybill
            this.WConcent = this.Waybill.Con
            this.WInfo = this.Waybill.WInfo
            this.WaynillInfo = []
            this.WayArr = []
            this.PlanArriveDate = new Date(this.WConcent.PlanArriveDate).Format('yyyy-MM-dd hh:mm:ss')
            this.sumWeight = this.WConcent.Weight
            this.sumCost = this.WConcent.Cost
            for (let i = 0; i < this.Waybill.WaynillInfo.length; i++) {
              const ele = this.Waybill.WaynillInfo[i];
              this.WayArr.push(ele.WaybillNo)
              this.WaynillInfo.push({
                CountryCode: ele.DestinationCode,
                DestCountryName: ele.DestinationName,
                WaybillNO:ele.WaybillNo
              })
            }
            this.selIndex = this.WayArr
            this.trueOrd()
          }
        } 
      });
    },
    trueOrd() {
      this.setServTime(true)
      this.LinkTel = this.WConcent.LinkTel
      this.LinkManName = this.WConcent.LinkManName
      this.Address = this.WConcent.Address
      this.Remark = this.WConcent.Remark
    },
    flaseOrd() {
      let PlanCargoDate = new Date(this.Concent.PlanCargoDate).Format('yyyy-MM-dd')+' 23:59:59'
      this.setServTimeApi(PlanCargoDate)
      this.LinkTel = this.Concent.LinkTel
      this.LinkManName = this.Concent.LinkManName
      this.Address = this.Concent.Address
      this.DestAddress = this.Concent.DestAddress
      this.Remark = this.Concent.Remark
      this.LadingName = this.Concent.DestContactName
      this.LadingPhone =  this.Concent.DestContactMobile
      if(this.OrderData.Volume == 0) {
        this.Volume = ''
      } else {
        this.Volume =  this.OrderData.Volume 
      }
      this.Weight =  this.OrderData.Weight
      this.Quantity = this.OrderData.PCS
    },
    //发件人地址栏弹框
    clkSendAddrBox(flag){
      this.isStartInfo = flag
      // 1 代表是收件人信息  2 代表是收件人信息
      this.$refs.senderBox.clkDialog();
    },
    //发件人地址库点击选择按钮
    showMsgSender(msg){
      if(this.isStartInfo) {
        this.LinkManName =msg.Address_Name
        this.LinkTel =msg.Address_Tel
        this.Address =msg.Address_Street+msg.Address_City+msg.Address_ZIPCode+msg.Address_Country
        this.LinkEmail = msg.Address_Mail
      } else {
        this.LadingName = msg.Address_Name
        this.LadingPhone = msg.Address_Tel
        this.DestAddress  =msg.Address_Street+msg.Address_City+msg.Address_ZIPCode+msg.Address_Country
      }
    },
    // 
    blur() {
      this.WeightTip = true
      this.VolumeTip = true
      this.QuantityTip = true
      this.LinkTelTip = true 
      this.LinkEmailTip = true 
      this.PlanCargoDateTip = true
     },
    //  默认赋值12点
    getPlanDate(flag) {
      this.PlanCargoDate = new Date(this.PlanCargoDate).Format('yyyy-MM-dd')+' 23:59:59'
      if(flag) {
        this.cascader()
      }
    },
    EmailBlur() {
      var emailReg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (!emailReg.test(this.LinkEmail)) {
        this.LinkEmail = ''
        this.PEReqiure = 'Please enter a valid email address'
      }
    },
    //非关联
    async setServTimeApi(PlanCargoDate){
      let res = await this.getServTimeApi()
      this.servTimeOptions= res
      this.PlanCargoDate = PlanCargoDate
    },
    queryTh() {
      this.api.url = this.$api01 + '/api/InfoCustomer/PickupCalculation/QueryPrice'
      this.api.param = {
          "PlanDate": this.PlanCargoDate,
          "ShipmentUnit": 0,
          "Weight":Number(this.Weight),
          "Volume":Number(this.Volume),
          "THFreightKey":this.OrderData.THFreightKey,
          "ChannelType": 1,
          "StartCityKey": this.Concent.CityKey,
          "EndCityKey": this.Concent.DestCityKey,
          "ResponseType": 2,
          "Skip": 0,
          "Take": 10,
      }
      return new Promise((resolve, reject) => {
        post(this.api.url, this.api.param).then(response => {
          let a = response;
          resolve(a);
        });
      });
      
    },
    //非关联
    async sumbitTh(){
      if( !(this.LinkTel || this.LinkEmail)) {
        this.PEReqiure = 'Phone or email required'
      }
      this.blur()
      if(  !(this.LinkTel || this.LinkEmail) ||
          !(this.Weight  || this.Volume) || !this.Quantity  ||!this.PlanCargoDate   ) {
        return false
      }
      let NoTime = false
      if(new Date(this.PlanCargoDate).getTime() < new Date().getTime()+30*60*1000 ) {
        NoTime = true
        this.$alert( "No pickup service",'',  {
          customClass:'custom-message-box', //自定义添加Class
          confirmButtonText: 'Confrim',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
          center: true
          }).then(() => {
          }).catch(() => {
        });
      }
      if(NoTime) {
        return false
      }
      this.loading = true
      let res = await this.queryTh()
      if(!res.IsOK) {
        this.loading = false
        this.$alert( "No pickup service",'',  {
          customClass:'custom-message-box', //自定义添加Class
          confirmButtonText: 'Confirm',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
          center: true
          }).then(() => {
            this.loading = false
          }).catch(() => {
        });
      }
      if(res.Results.length == 0) {
        this.loading = false
        this.$alert( "No pickup service",'',  {
          customClass:'custom-message-box', //自定义添加Class
          confirmButtonText: 'Confirm',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
          center: true
          }).then(() => {
          }).catch(() => {
        });
      } else {
        this.oldSumCost = this.sumCost
        this.newSumCost = res.Results[0].PickupFee
        this.sumCost = this.newSumCost
        this.loading = false
        this.sumbitBtn = true
      }

    },
    LinkTelBlur(val) {
      if( !(/^[0-9-]+$/.test(this[val]) )) {
        this[val] = ''
      }
    },

    //1快递 ，2 小包 ，3 空运，4海运整柜，5海运散货,20 FBA头程
    typeConversion(val){
      if(val==1) return'Express'
      if(val==3) return'Air Freight'
      if(val==20) return'FBA头程'
    }, 
    // 非关联
    falseUpdataTh() {
      this.sumbitBtn= false
      let status = false
      if(this.OrderData.billStatus!= 1 && this.OrderData.billStatus!= 2) {
        status = true
        this.$alert( 'The picking list status has been updated and cannot be edited','',  {
          customClass:'custom-message-box', //自定义添加Class
          confirmButtonText: 'Confirm',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
          center: true
          }).then(() => {
          }).catch(() => {
        });
      }
      if(status) {
        return false
      }
      this.api.url = this.$api03 + '/api/TradeCustomer/PickupOrdersEnglish/PickupUpdateOrderOnly'
      this.api.param = {
        "THBillNo": this.Concent.THBillNo,
        "THFreightKey": this.OrderData.THFreightKey,
        "PickupFee": this.OrderData.Cost,
        "Remark": this.Remark,
        "Weight": this.Weight,
        "Volume": Number(this.Volume),
        "Quantity": this.Quantity,
        "ConnectInfo": {
          // "AreaKey": this.Concent.AreaKey,
          "CityKey": this.Concent.CityKey,
          "LinkManName": this.LinkManName,
          "LinkTel": this.LinkTel,
          "Address": this.Address,
          "LinkEmail": this.LinkEmail,
          "Remark": this.Remark,
          "DestAddress": this.DestAddress,
          "DestContactMobile": this.LadingPhone,
          "DestContactName": this.LadingName,
          "PlanCargoDate": this.PlanCargoDate,
          "DestCityKey": this.Concent.DestCityKey,
          // "DestCityAreaKey": this.Concent.DestCityAreaKey,
          "PlanArriveDate": this.Concent.PlanArriveDate
        },
        "GoodsInfos": [this.GoodsInfos]
      }
      post(this.api.url, this.api.param).then(res => {
        if(res.IsOK) {

          let startText=this.Concent.ProvinceNameEn+"["+this.Concent.CityNameEn+']'
          let endText=this.Concent.DestProvinceNameEn+"["+this.Concent.DestCityNameEn+']'


         // this.submitOrder(this.Concent.THBillNo,this.OrderData.Cost,this.OrderData.Cost,'Pick-up service',startText,'',endText,'',
         // '',this.Weight,this.Volume,this.Quantity,'','','',this.OrderData.Cost,'','',false)



            let list = [{
            THBillNo: this.Concent.THBillNo,
            WareID:this.OrderData.Wid, 
            Origin: 0, 
            WAddr: null
            }]
          this.sumbitBtn = false
          // sessionStorage.setItem('urlList', JSON.stringify(list))
          sessionStorage.setItem('urlList', JSON.stringify({list:list,ordNumCost:this.sumCost}))
          this.$router.push({path: '/pickUp/PickupOrderSucceed'}) 
        } else {
          this.$alert( 'fail','',  {
            customClass:'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
            center: true
            }).then(() => {
              this.sumbitBtn = false
            }).catch(() => {
          });
        }
      });
      // 结束
    },
    getServTimeApi() {
      let that=this
      this.api.param= {
        startCityKey:this.Concent.CityKey,
        // startCityKey:this.$route.query.StartCityAreaKey,
        endCityKey:this.Concent.DestCityKey,
        // endCityKey:this.$route.query.StartCityAreaKey,
        tHFreightKey:this.OrderData.THFreightKey,
        channelType:1,
      }
      // this.api.url=this.$api01+"/api/InfoCustomer/PickupChannel/ServiceTimeEn"
      this.api.url=this.$api04 + "/Pickup/api/PickupChannel/ServiceTimeEn"
      return new Promise((resolve, reject) => {
        fetch(that.api.url, that.api.param).then(res => {
          if (res.IsOK) {
            resolve(res.Results);
          }
        });
      });
    },
    // end 
    //关联
    async sumbitTrueTh(){
      if( !(this.LinkTel || this.LinkEmail)) {
        this.PEReqiure = 'Phone or email required'
      }
      if(this.WaynillInfo.length<1) {
        this.$alert( 'Please select an international order','',  {
          customClass:'custom-message-box', //自定义添加Class
          confirmButtonText: 'Confirm',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
          center: true
          }).then(() => {
          }).catch(() => {
        });
      }
      this.blur()
      let NoTime = false
      if(new Date(this.PlanCargoDate).getTime() < new Date().getTime()+30*60*1000 ) {
        NoTime = true
        this.$alert( "There is no service for the current pickup time. Please reselect the pickup time",'',  {
          customClass:'custom-message-box', //自定义添加Class
          confirmButtonText: 'Confirm',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
          center: true
          }).then(() => {
          }).catch(() => {
        });
      }
      if( !(this.LinkTel || this.LinkEmail) ||  
        !this.PlanCargoDate || this.WaynillInfo.length<1 || NoTime
        ) {
        return false
      }
      this.loading = false
      this.sumbitTrueBtn = true
    },
    UpdataTh() {
      this.sumbitTrueBtn = false
      let status = false
      if(this.WConcent.billStatusStr!= '派单中'&& this.WConcent.billStatusStr!= '待取件') {
        status = true
        this.$alert( 'The picking list status has been updated and cannot be edited','',  {
          customClass:'custom-message-box', //自定义添加Class
          confirmButtonText: 'Confirm',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
          center: true
          }).then(() => {
          }).catch(() => {
        });
      }
      if(status) {
        return false
      }
      this.api.url = this.$api03 + '/api/TradeCustomer/PickupOrdersEnglish/Update'
      let waybillArr = []
      for (let i = 0; i < this.WayArr.length; i++) {
        const ele = this.WayArr[i]
        waybillArr.push({
          WaybillNo:ele
        })
      }
      this.api.param ={
        "THBillNo": this.WConcent.THBillNo,
        "THFreightKey":  this.WConcent.THFreightKey,
        "Remark": this.Remark,
        "WareID":  this.WConcent.Wid,
        "PickupFee": this.WConcent.Cost,
        "GoodsInfos": this.GoodsInfo,
        "GoodsInfo":waybillArr,
        "ConnectInfo": {
          "LinkManName":this.LinkManName,
          "LinkTel":this.LinkTel,
          "Address":this.Address,
          "PlanCargoDate": this.PlanCargoDate,
          "Remark":this.Remark,
          "LinkEmail": this.LinkEmail,
          "CityKey": this.WConcent.City_Key,
          "ProvinceKey": this.WConcent.Province_Key,
          "ProvinceName":this.ProvinceName,
          "CityName": this.WConcent.CityName,
          "DestCityKey": this.WInfo.CityKey,
          "DestProvinceName": this.WInfo.Province_NameCh,
          "DestCityName": this.WInfo.City_NameCh,
          "DestCityAreaName": this.WInfo.CityArea_NameCh,
          "PlanArriveDate": this.WConcent.PlanArriveDate
        }
      }
      post(this.api.url, this.api.param).then(res => {
        if(res.IsOK) {

          let startText=this.Concent.ProvinceNameEn+"["+this.Concent.CityNameEn+']'
          let endText=this.Concent.DestProvinceNameEn+"["+this.Concent.DestCityNameEn+']'

         // this.submitOrder(this.Concent.THBillNo,this.OrderData.Cost,this.OrderData.Cost,'Pick-up service',startText,'',endText,'',
         // '',this.Weight,this.Volume,this.Quantity,'','','',this.OrderData.Cost,'','',false)


           let list = [{
            THBillNo:  this.WConcent.THBillNo,
            WareID:this.WConcent.Wid, 
            Origin: 0, 
            WAddr: this.WInfo.WareAddress
           }]
          // sessionStorage.setItem('urlList', JSON.stringify(list))
          sessionStorage.setItem('urlList', JSON.stringify({list:list,ordNumCost:this.sumCost}))
          this.$router.push({path: '/pickUp/PickupOrderSucceed'}) 
        } else {
          this.$alert( 'fail','',  {
            customClass:'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
            center: true
            }).then(() => {
            }).catch(() => {
          });
        }
      });
      // 结束
    },
    setServTime(first){
      let that=this
      this.api.param={
        startCityKey:this.WConcent.City_Key,
        // endCityKey:this.WInfo.CityKey,
        tHFreightKey:this.WConcent.THFreightKey,
        ChargeWeight:this.sumWeight,
        channelType:1,
      }
      // this.api.url=this.$api01+"/api/InfoCustomer/PickupChannel/ServiceTimeEn"
      this.api.url=this.$api04 + "/Pickup/api/PickupChannel/ServiceTimeEn"
      fetch(this.api.url,this.api.param).then(function (res) {
        if(res.IsOK){
          that.servTimeOptions=res.Results
          if(first) {
            that.PlanCargoDate = new Date(that.WConcent.PlanCargoDate).Format('yyyy-MM-dd')+' 23:59:59'
          }
        }
      })
    },
    cancel() {
      this.addOrderBox=false
    },
    // 去掉取件单
    reduceWay(WaybillNO) {
      this.$confirm('Are you sure you want to delete this order?','',  {
        customClass: "custom-message-box", //自定义添加Class
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
        closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
        center: true
        }).then(() => {
          this.loading = true
          var WaybillArr = JSON.parse(JSON.stringify(this.WayArr))
          var index = WaybillArr.indexOf(WaybillNO)
          WaybillArr.splice(index,1)
          if(WaybillArr.length == 0) {
            this.WaynillInfo = []
            this.sumCost = 0
            this.loading = false
          } else {
            this.makePickUpApi(WaybillArr,true) 
          }
        }).catch(() => {
      });
    },
    cascader() {
      this.loading = true
      this.makePickUpApi(this.WayArr)
    },
    // 全选和全不选
    isCheckAll(val) {
      let set = `${val}Sel`
      let data =  `${val}All`
      if(this[data]) {
        this.ordTableData.forEach(item => {
          if(item.WareAddress.indexOf(this.WInfo.WareAddress) != -1) {
            item[set] = true
            this.selIndex.push(item.WaybillNO)
          }
        })
      } else {
        this.ordTableData.forEach(item => {
          var index = this.selIndex.indexOf(item.WaybillNO)
          this.selIndex.splice(index,1);
          item[set] = false
        })
      }
    },
    knowIsCheck(WaybillNO,index) {
      let checkAll = true
      if(this.ordTableData[index].ThcheckSel) {
        this.selIndex.push(WaybillNO)
      } else {
        var index = this.selIndex.indexOf(WaybillNO)
        this.selIndex.splice(index,1);
      }
      for (let i = 0; i < this.ordTableData.length; i++) {
        const ele = this.ordTableData[i]
        if(!ele.ThcheckSel) {
          checkAll = false
        }
      }
      this.ThcheckAll = checkAll
    },
    makePickUp() {
      this.WayArr = this.selIndex
      this.WayArr = [...new Set(this.WayArr)] 
      this.makePickUpApi(this.WayArr) 
    },
    // 分取件单
    makePickUpApi(WaybillTypeArr,getArr) {
      // WaybillTypeArr = [...new Set(WaybillTypeArr)] 
      let plan = ''
      if(!this.PlanCargoDate) {
        plan = new Date(this.WConcent.PlanCargoDate).Format('yyyy-MM-dd hh:mm:ss')
      } else {
        plan = this.PlanCargoDate
      }
      this.api.url = this.$api01 + '/api/PickupChannel/Make'
      this.api.param = {
        "CityKey": this.WConcent.City_Key,
        "PlanCargoDate": plan,
        "ChannelType": 1,
        "WaybillNO":WaybillTypeArr,
      }
      post(this.api.url, this.api.param).then(res => {
        if(res.IsOK) {
          if(getArr) {
            this.WayArr = WaybillTypeArr
          }
          this.loading = false
          this.ordInfoArr = res.Results
          this.WaynillInfo = res.Results[0].OrdersList
          this.sumWeight = res.Results[0].Weight
          this.sumCost = res.Results[0].PickupFee
          this.PlanArriveDate= new Date(new Date(new Date(this.PlanCargoDate).setDate(new Date(this.PlanCargoDate).getDate()+Number(res.Results[0].WorkDays)))).Format('yyyy-MM-dd')+' 23:59:59'
          this.addOrderBox=false
        } else {
          if(res.ErrorCode == 'H0001') {
            this.$alert( 'The order you selected is overweight. Please place an order in multiple tickets','',  {
                customClass:'custom-message-box', //自定义添加Class
                confirmButtonText: 'Confirm',
                cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
                closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
                center: true
                }).then(() => {
                  this.loading = false
                }).catch(() => {
              });

          } else {
            this.$alert('fail','',  {
                customClass:'custom-message-box', //自定义添加Class
                confirmButtonText: 'Confirm',
                cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
                closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
                center: true
                }).then(() => {
                  this.loading = false
                }).catch(() => {
              });
          }
        }
      });
    },
 
    datetime() {
      this.OrderEndDate  = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1);
      let OrderStartDate = new Date(new Date().setMonth(this.OrderEndDate.getMonth()-1))
      this.OrderStartDate = new Date(new Date(new Date(OrderStartDate).toLocaleDateString()).getTime());
    },
    leaveInfo () {
      this.curShow= false
    },
    getPickDetail(WaybillNO) {
      //console.log(WaybillNO)
      this.api.url = this.$api03 + '/api/PickupOrders/CargoByBillNO'
      this.api.param = {
        "WaybillNO": WaybillNO
      }
      fetch(this.api.url, this.api.param).then(res => {
        if(res.IsOK) {
          this.curOrdInfo = res.Results
          this.curShow = true
        } 
      });
    },

    getWareAdd(WareId) {
      this.api.url = this.$api01 + '/api/InfoCustomer/Warehouse/Query'
      this.api.param = {
        id:WareId
      }
      fetch(this.api.url, this.api.param).then(res => {
        if(res.IsOK) {
          this.wareAdd = res.Results
        } 
      });
    },
    // 分页
    handleSizeChange(val) {
      this.currentPage = 1
      this.Skip = 0
      this.Take = val
      this.getCargoQuery()
    },
    handleCurrentChange(val) {
      this.Skip = (val-1)*this.Take
      this.getCargoQuery()
    },
    getCargoQuery() {
      this.addOrderBox=true
      this.queryWait = true
      // this.api.url = this.$api03 + '/api/TradeCustomer/PickupOrders/CargoQuery'
      this.api.url = this.$api04 + '/Pickup/api/PickupOrderQuery/CargoQuery';
      this.api.param = {
        "THBillNo":this.THBillNo,
        "CityKey": this.WConcent.City_Key,
        "WareId":  this.WConcent.Wid,
        "PlanCargoDate": this.WConcent.PlanCargoDate,
        "WaybillType": this.WaybillType,
        "OrderStartDate":this.OrderStartDate,
        "OrderEndDate": this.OrderEndDate,
        "Skip": this.Skip,
        "Take": this.Take,
        "ChannelType": 1,
      }
      post(this.api.url, this.api.param).then(res => {
        if(res.IsOK) {
          this.ordTableData = res.Results
          for (let i = 0; i < this.ordTableData.length; i++) {
            const ele = this.ordTableData[i];
            if(this.selIndex.indexOf(ele.WaybillNO)!== -1) {
              ele.ThcheckSel = true
            } else {
              ele.ThcheckSel = false
            }
            ele.ordNo = this.Skip+i+1
          }
          this.Total = Number(res.Total) 
          this.queryWait = false
        } 
      });
    },
    // 验证
    falseZero(val) {
      if(this[val] == 0) {
        this[val] = ''
      }
      if(val == 'Volume' || val == 'Weight') {
        if(this[val].indexOf('.') != -1) {
          let le = this[val].split('.')
          if(le.length>2) {
            this[val] = ''
          }
        }
      }
    },
    pickAddr() {
      if(!this.discernInfo) {
        this.discernInfoTip = true 
        return false
      }
      this.api.url = this.$api02 + '/api/EbayCustomer/PickupAddr/DiscernEn'
      this.api.param = {
        "textbox": this.discernInfo
      }
      fetch(this.api.url, this.api.param).then(res => {
        if(res.IsOK) {
          this.LinkManName = res.Results.FullName
          this.LinkTel = res.Results.Phone
          this.Address = res.Results.Address
          this.LinkEmail =  res.Results.Mailbox
        } 
      });
      // 结束
      this.discernBox = false
    },
    pickAddr1() {
      if(!this.discernInfo1) {
        this.discernInfoTip1 = true 
        return false
      }
      this.api.url = this.$api02 + '/api/EbayCustomer/PickupAddr/DiscernEn'
      this.api.param = {
        "textbox": this.discernInfo1
      }
      fetch(this.api.url, this.api.param).then(res => {
        if(res.IsOK) {
          this.LadingName = res.Results.FullName
          this.LadingPhone = res.Results.Phone
          this.DestAddress = res.Results.Address
        } 
      });
      // 结束
      this.discernBox1 = false
    },

  }
}



// WEBPACK FOOTER //
// ./src/assets/js/userCenter/pickup/pickUpEdit.js